export enum EnumSteps {
	ACCEPTED = 'accepted',
	APPLIED = 'applied',
	IGNORED = 'ignored',
	MATCHED = 'matched',
	PROPOSED = 'proposed',
	REFUSED = 'refused',
}

export enum EnumSpecificationSteps {
	IGNORED = 'ignored',
	MATCHED = 'matched',
	UPDATED = 'updated',
}
